import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/updateAndPublish/${number | ':workOrderId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/updateAndPublish/:workOrderId`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/updateAndPublish/${workOrderId}`;
